module.exports = "<div innerHTML=\"{{text}}\"></div>\n"